// Single source of WhatsApp prefill text for every BPO Contact CTA.
// The shared number serves several group brands, so each text names BPO Contact and the website.
// The visitor can still edit or delete it before sending: this helps, but never guarantees attribution.
export const WA_PREFILL: Record<string, string> = {
  en: "Hello BPO Contact, I'm writing from the bpo-contact.com website and would like to know more about your services.",
  fr: "Bonjour BPO Contact, je vous écris depuis le site bpo-contact.com et j'aimerais en savoir plus sur vos services.",
  es: "Hola BPO Contact, les escribo desde el sitio web bpo-contact.com y me gustaría saber más sobre sus servicios.",
  ar: "مرحباً BPO Contact، أكتب إليكم من موقع bpo-contact.com وأود معرفة المزيد عن خدماتكم.",
  de: "Hallo BPO Contact, ich schreibe Ihnen über die Website bpo-contact.com und möchte mehr über Ihre Leistungen erfahren.",
  it: "Buongiorno BPO Contact, vi scrivo dal sito bpo-contact.com e vorrei saperne di più sui vostri servizi.",
  pt: "Olá BPO Contact, escrevo a partir do site bpo-contact.com e gostaria de saber mais sobre os vossos serviços.",
  nl: "Hallo BPO Contact, ik schrijf u via de website bpo-contact.com en wil graag meer weten over uw diensten.",
  pl: "Dzień dobry BPO Contact, piszę ze strony bpo-contact.com i chciałbym dowiedzieć się więcej o Waszych usługach.",
  tr: "Merhaba BPO Contact, size bpo-contact.com web sitesinden yazıyorum ve hizmetleriniz hakkında daha fazla bilgi almak istiyorum.",
  ru: "Здравствуйте, BPO Contact! Пишу вам с сайта bpo-contact.com и хотел бы узнать больше о ваших услугах.",
  zh: "您好，BPO Contact！我是通过 bpo-contact.com 网站联系您的，想进一步了解贵公司的服务。",
  ja: "こんにちは、BPO Contact様。bpo-contact.com のウェブサイトから連絡しています。サービスについて詳しく教えてください。",
  ko: "안녕하세요, BPO Contact. bpo-contact.com 웹사이트를 보고 연락드립니다. 서비스에 대해 더 알고 싶습니다.",
  sv: "Hej BPO Contact, jag skriver via webbplatsen bpo-contact.com och vill gärna veta mer om era tjänster.",
  da: "Hej BPO Contact, jeg skriver via hjemmesiden bpo-contact.com og vil gerne høre mere om jeres tjenester.",
};

export const waPrefill = (lang: string) => WA_PREFILL[lang] || WA_PREFILL.en;
// WA-CTX-3010: localized "page" label appended only for a public service page.
const WA_PAGE_LABEL: Record<string, string> = {
  en: 'Page', fr: 'Page', es: 'Página', ar: 'الصفحة', de: 'Seite', it: 'Pagina', pt: 'Página', nl: 'Pagina',
  pl: 'Strona', tr: 'Sayfa', ru: 'Страница', zh: '页面', ja: 'ページ', ko: '페이지', sv: 'Sida', da: 'Side',
};
/**
 * Public service page path (language prefix removed) or null. Only /services/<…>
 * pages that are not family hubs qualify; query, hash, private areas and unsafe
 * characters never reach the message.
 */
export function waServicePage(pathname?: string): string | null {
  if (!pathname) return null;
  const path = pathname.split(/[?#]/)[0];
  if (!/^\/[a-z]{2}\/services\/[a-z0-9-]+(\/[a-z0-9-]+)*\/?$/.test(path)) return null;
  const page = path.replace(/^\/[a-z]{2}/, '').replace(/\/$/, '');
  if (['/services/bpo', '/services/digital-studio'].includes(page)) return null;
  return page.slice(0, 100);
}
export const waHref = (number: string, lang: string, pathname?: string) => {
  const page = waServicePage(pathname);
  const text = page ? `${waPrefill(lang)} (${WA_PAGE_LABEL[lang] || WA_PAGE_LABEL.en}: bpo-contact.com/${/^[a-z]{2}$/.test(lang) ? lang : 'en'}${page})` : waPrefill(lang);
  return `https://wa.me/${number.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(text)}`;
};
